import './data';
import './new';
import './announcement';
import Mock from 'mockjs';

Mock.setup({
});


// WEBPACK FOOTER //
// ./src/api/mock/index.js